import { faUpload } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, styled, Tooltip, TooltipProps } from "@mui/material";
import { FC, useCallback, useState } from "react";
import ImageUploadDialog from "./ImageUploadDialog";
import { AppSettings } from "../../AppSettings";



const TableButtonsBox = styled(Box)(() => ({
    display: 'flex',
    gap: 8,
    height: '100%',
    alignItems: 'center',

}));
const StyledButton = styled(IconButton)(({theme}) => ({
    padding: theme.spacing(0),
    color: theme.palette.mode === 'dark' ?
        `${AppSettings.palette.primaryDark} !important` :
        `${AppSettings.palette.primaryLight} !important`, 

    '&:hover': {
        color: theme.palette.mode === 'dark' ?
        `${theme.palette.primary.light} !important` :
        `${theme.palette.primary.dark} !important`, 
        background: 'none',
    },

    '&:last-of-type': {
        marginRight: theme.spacing(0)
    }
}));

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ tooltip: className }} />
))(({ theme }) => ({
    
    backgroundColor: theme.palette.mode === 'dark' ?
        `rgba(0, 0, 0, 0.87)` :
        theme.palette.common.white,
    color: theme.palette.mode === 'dark' ?
    theme.palette.common.white :
        `rgba(0, 0, 0, 0.87)`,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    
}));

interface IImageCell {
    uploadId: number | undefined;
    displayImage?: boolean;
    displayCem?: boolean;
}

const UploadCell: FC<IImageCell> = ({
    uploadId,
    displayImage,
    displayCem
}) => {


    const [dialogOpen, setDialogOpen] = useState(false);

    const [imageUploadId, setImageUploadId] = useState<number | undefined>(undefined);
    
    const onClick = useCallback((id: number | undefined) => {
        setImageUploadId(id);
        setDialogOpen(true);
    }, [setImageUploadId, setDialogOpen]);

    return (
        <>
            {
                imageUploadId && (
                    <ImageUploadDialog
                        dialogOpen={dialogOpen}
                        setDialogOpen={setDialogOpen}
                        imageUploadId={imageUploadId}
                        setImageUploadId={setImageUploadId}
                        displayImage={displayImage}
                        displayCem={displayCem}
                    />
                )
            }
            <TableButtonsBox>
                <StyledTooltip title="Upload">
                    <StyledButton
                        size="medium"
                        onClick={(e) => {onClick(uploadId); e.stopPropagation();}}
                    >
                        <FontAwesomeIcon icon={faUpload} fixedWidth />
                    </StyledButton>
                </StyledTooltip>
            </ TableButtonsBox>
        </>
    );
}

export default UploadCell;